import React from 'react'
import { Modal, Button } from 'web/src/app/root/components/common'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { Typography } from '@material-ui/core'

export const InvitationConfirmModal = ({ open, setOpen, onSendClick }) => {
    const { locale } = useSelector(state => state.main)

    return (
        <Modal open={open} setOpen={setOpen}>
            <Typography>{locale.userManagement.invitationModalText}</Typography>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 40,
                    gap: 20
                }}>
                <Button
                    onClick={() => {
                        onSendClick()
                        setOpen(false)
                    }}>
                    {locale.reports.send}
                </Button>
                <Button reverted onClick={() => setOpen(false)}>
                    {locale.common.cancel}
                </Button>
            </Box>
        </Modal>
    )
}
